<template>

    <div class="hero container-fluid" :class="{ 'hero-small': smallHero}">

        <div class="swiper-container">
            <div class="swiper-wrapper">
                <a href="#" class="swiper-slide" :key="slide.id" v-for="slide in slides" :style="'background-image:url(' + slide.image + ');'">
                    <div class="hero-details" :class="slide.imgTheme">
                        <h3 class="hero-subtitle">{{ slide.subtitle }}</h3>
                        <h2 class="hero-title">{{ slide.title}}</h2>
                        <div class="hero-caption">{{ slide.caption }}</div>
                    </div>
                </a>
            </div>
            <div class="swiper-button-prev">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
            </div>
            <div class="swiper-button-next">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
            </div>
        </div>
    </div>
	
</template>

<script>

	export default {
		name: 'Hero',
		
		props: ['slides', 'smallHero']
	}
	
</script>